import { useState, useMemo, useEffect, useRef } from "react";

import addIconGold from "../../../assets/Add-icon-gold.svg";
import downloadImg from "../../../assets/download.svg";
import NewChangesTabs from "../../new-client-dashboard/NewChangesTabs";
import TreatmentTabs from "../../TreatmentPage/TreatmentTabs";
import TabsClient from "../../new-client-dashboard/Tabs";
import { api_without_cancellation } from "../../../api/api";
import FirmReportingCaseMgmt from "../tabs/firm-reporting-case-mgmt";
import CommonTabsAcrossPlatform from "../../common/Tabs/CommonTabsAcrossPlatform";
import ExportReportModal from "../download-modal";
import {
  exportCaseMgmtToCSV,
  exportCaseMgmtToXLSX,
  exportCaseMgmtToPDF,
} from "../utils/export-utils";

import CaseMgmtDurationModal from "./case-mgmt-duration-modal";
import CaseMgmtReportValueModal from "./case-mgmt-report-value-modal";
import CaseMgmtSaveTemplateModal from "./case-mgmt-save-report-modal";

const CaseMgmtHeader = ({ currentPage, mainTabs, mainRef2 }) => {
  const [showDurationModal, setShowDurationModal] = useState(false);
  const [showReportValueModal, setShowReportValueModal] = useState(false);
  const [showSaveTemplateModal, setShowSaveTemplateModal] = useState(false);
  const [templateActive, setTemplateActive] = useState(null);
  const controlRef = useRef(null);
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [_loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [downloadModal, setDownloadModal] = useState(false);
  // Mock data for dropdowns - replace with actual API data
  const [caseStages, setCaseStages] = useState([]);

  const [caseStatuses, setCaseStatuses] = useState([]);

  const fetchCaseStage = async () => {
    try {
      setLoading(true);
      const response = await api_without_cancellation.get("/api/stages/");
      if (response.status === 200) {
        setCaseStages(response?.data);
      }
    } catch (error) {
      console.error("Error loading templates:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCaseStatus = async () => {
    try {
      setLoading(true);
      const response = await api_without_cancellation.get("/api/statuses/directory/");
      if (response.status === 200) {
        setCaseStatuses(response?.data?.data);
      }
    } catch (error) {
      console.error("Error loading templates:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCaseStage();
    fetchCaseStatus();
  }, []);

  const [currentConfig, setCurrentConfig] = useState({
    duration: {
      date_type: "",
      date_range_start: "",
      date_range_end: "",
      current_day: false,
      current_week: false,
      current_month: false,
      previous_month: false,
      current_quarter: false,
      previous_quarter: false,
      selected_years: [],
    },
    screenBy: {
      case_stage: "",
      case_status: "",
    },
    reportValues: {
      has_issues: false,
      screen_by_stage: false,
      screen_by_status: false,
      is_flagged: false,
    },
  });

  useEffect(() => {
    loadTemplates();
  }, []);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const response = await api_without_cancellation.get(
        "/api/firm-reporting/firm-reporting-templates/"
      );
      if (response.status === 200 && response.data?.data) {
        setSavedTemplates(
          response.data.data?.filter((report) => report?.report_tab === "case_management")
        );
      }
    } catch (error) {
      console.error("Error loading templates:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDurationSave = (durationData) => {
    setCurrentConfig((prev) => ({
      ...prev,
      duration: durationData,
    }));
    setShowDurationModal(false);
  };

  const handleReportValuesSave = (data) => {
    setCurrentConfig((prev) => ({
      ...prev,
      reportValues: data.values,
      screenBy: data.screenBy,
    }));
    setShowReportValueModal(false);
  };

  const handleSaveTemplate = async (templateName) => {
    try {
      if (templateActive?.id) {
        // Update existing template
        const payload = {
          id: templateActive?.id,
          template_name: templateName,
          // Duration fields
          report_tab: "case_management",
          date_type: currentConfig.duration.date_type,
          date_range_start: currentConfig.duration.date_range_start || null,
          date_range_end: currentConfig.duration.date_range_end || null,
          current_day: currentConfig.duration.current_day,
          current_week: currentConfig.duration.current_week,
          current_month: currentConfig.duration.current_month,
          previous_month: currentConfig.duration.previous_month,
          current_quarter: currentConfig.duration.current_quarter,
          previous_quarter: currentConfig.duration.previous_quarter,
          selected_years: currentConfig.duration.selected_years,
          // Screen By fields
          case_stage: currentConfig.screenBy.case_stage,
          case_status: currentConfig.screenBy.case_status,
          screen_by_stage: currentConfig?.reportValues?.screen_by_stage,
          screen_by_status: currentConfig?.reportValues?.screen_by_status,
          has_issues: currentConfig.reportValues.has_issues,
          is_flagged: currentConfig.reportValues.is_flagged,
          // Report Values
        };

        const response = await api_without_cancellation.patch(
          "/api/firm-reporting/firm-reporting-templates/",
          payload
        );

        if (response.status === 200 || response.status === 201) {
          await loadTemplates();
          setShowSaveTemplateModal(false);
        }
      } else {
        // Create new template
        const payload = {
          template_name: templateName,
          // Duration fields
          report_tab: "case_management",
          date_type: currentConfig.duration.date_type,
          date_range_start: currentConfig.duration.date_range_start || null,
          date_range_end: currentConfig.duration.date_range_end || null,
          current_day: currentConfig.duration.current_day,
          current_week: currentConfig.duration.current_week,
          current_month: currentConfig.duration.current_month,
          previous_month: currentConfig.duration.previous_month,
          current_quarter: currentConfig.duration.current_quarter,
          previous_quarter: currentConfig.duration.previous_quarter,
          selected_years: currentConfig.duration.selected_years,
          // Screen By fields
          case_stage: currentConfig.screenBy.case_stage,
          case_status: currentConfig.screenBy.case_status,
          screen_by_stage: currentConfig?.reportValues?.screen_by_stage,
          screen_by_status: currentConfig?.reportValues?.screen_by_status,
          has_issues: currentConfig.reportValues.has_issues,
          is_flagged: currentConfig.reportValues.is_flagged,
        };

        const response = await api_without_cancellation.post(
          "/api/firm-reporting/firm-reporting-templates/",
          payload
        );

        if (response.status === 200 || response.status === 201) {
          await loadTemplates();
          setShowSaveTemplateModal(false);
        }
      }
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Failed to save template. Please try again.");
    }
  };

  const handleTemplateClick = (template) => {
    // Toggle: if already selected, unselect
    if (templateActive?.id === template?.id) {
      setTemplateActive(null);
      setCurrentConfig({
        duration: {
          date_type: "",
          date_range_start: "",
          date_range_end: "",
          current_day: false,
          current_week: false,
          current_month: false,
          previous_month: false,
          current_quarter: false,
          previous_quarter: false,
          selected_years: [],
        },
        screenBy: {
          case_stage: "",
          case_status: "",
        },
        reportValues: {
          has_issues: false,
          screen_by_stage: false,
          screen_by_status: false,
          is_flagged: false,
        },
      });
      return;
    }

    // Load template
    const loadedConfig = {
      duration: {
        date_type: template.date_type || "",
        date_range_start: template.date_range_start || "",
        date_range_end: template.date_range_end || "",
        current_day: template.current_day || false,
        current_week: template.current_week || false,
        current_month: template.current_month || false,
        previous_month: template.previous_month || false,
        current_quarter: template.current_quarter || false,
        previous_quarter: template.previous_quarter || false,
        selected_years: template.selected_years || [],
      },
      screenBy: {
        case_stage: template.case_stage || "",
        case_status: template.case_status || "",
      },
      reportValues: {
        has_issues: template.has_issues || false,
        is_flagged: template.is_flagged || false,
        screen_by_stage: template?.screen_by_stage || false,
        screen_by_status: template?.screen_by_status || false,
      },
    };

    setTemplateActive(template);
    setCurrentConfig(loadedConfig);
  };

  const handleDeleteTemplate = async (templateId) => {
    if (!window.confirm("Are you sure you want to delete this template?")) {
      return;
    }

    try {
      const response = await api_without_cancellation.delete(
        `/api/firm-reporting/firm-reporting-templates/?id=${templateId}`
      );

      if (response.status === 204 || response.status === 200) {
        setSavedTemplates((prev) => prev.filter((t) => t.id !== templateId));

        // If deleted template was active, clear selection
        if (templateActive?.id === templateId) {
          setTemplateActive(null);
          setCurrentConfig({
            duration: {
              date_type: "",
              date_range_start: "",
              date_range_end: "",
              current_day: false,
              current_week: false,
              current_month: false,
              previous_month: false,
              current_quarter: false,
              previous_quarter: false,
              selected_years: [],
            },
            screenBy: {
              case_stage: "",
              case_status: "",
            },
            reportValues: {
              has_issues: false,
              screen_by_stage: false,
              screen_by_status: false,
              is_flagged: false,
            },
          });
          await loadTemplates();
        }
      }
    } catch (error) {
      console.error("Error deleting template:", error);
      alert("Failed to delete template. Please try again.");
    }
  };

  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "duration",
      label: "Duration",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setShowDurationModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    tabs.push({
      id: "values",
      label: "Values",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setShowReportValueModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    tabs.push({
      id: "save",
      label: "Save",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setShowSaveTemplateModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, []);

  const saveTemplateTabs = useMemo(() => {
    const tabs = [];

    savedTemplates?.forEach((template) => {
      tabs.push({
        id: template?.id,
        label: template?.template_name,
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        left: "0px",
        onClick: () => {
          handleTemplateClick(template);
        },
        rightHand: true,
        span: (
          <span className="fw-bold p-r-5 ic-15 d-flex align-items-center m-l-5">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteTemplate(template.id);
              }}
              style={{
                height: "15px",
                width: "15px",
                padding: "0",
                border: "none",

                background: "transparent",
                color: "red",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Delete template"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14H6L5 6" />
                <path d="M10 11v6" />
                <path d="M14 11v6" />
                <path d="M9 6V4h6v2" />
              </svg>
            </button>
          </span>
        ),
      });
    });

    return tabs;
  }, [savedTemplates, templateActive, handleTemplateClick, handleDeleteTemplate]);

  const downloadTabs = useMemo(() => {
    return [
      {
        id: "download",
        label: "Download",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        left: "0px",
        onClick: () => setDownloadModal(true),
        leftHand: true,
        span: (
          <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
            <img
              className="d-flex align-items-center justify-content-center"
              style={{ flexShrink: "0" }}
              src={downloadImg}
            />
          </span>
        ),
      },
    ];
  }, []);

  const handleExport = async (format, template, data) => {
    switch (format) {
      case "csv":
        exportCaseMgmtToCSV(template, data);
        break;
      case "xlsx":
        exportCaseMgmtToXLSX(template, data);
        break;
      case "pdf":
        exportCaseMgmtToPDF(template, data);
        break;
      default:
        console.error("Unknown export format:", format);
    }
  };

  return (
    <>
      <div
        className="reporting-controls-container d-flex align-items-center justify-content-start"
        style={{ padding: "0px 0px", width: "calc(100% - 100px)" }}
        ref={controlRef}
      >
        <div style={{ width: "max-content" }}>
          <NewChangesTabs
            currentTab={currentPage}
            tabsData={mainTabs}
            height={25}
            labelClass=" justify-content-start pe-2"
          />
        </div>
        <div className="add-tabs-section-three-tab">
          <TreatmentTabs
            labelClass="ps-2 pe-5"
            handlePage={currentPage}
            tabsData={buttonTabs}
            height={25}
          />
        </div>
        <CommonTabsAcrossPlatform
          currentTab={templateActive === null ? null : templateActive?.id}
          tabsData={saveTemplateTabs}
          height={25}
          labelClass=" justify-content-center ps-2 pe-2"
        />
        {reportData?.length > 0 && (
          <div style={{ position: "absolute", right: "0px" }}>
            <TabsClient
              tabsData={downloadTabs}
              height={25}
              labelClass="p-l-5 pe-0 justify-content-end me-0"
            />
          </div>
        )}
      </div>

      <FirmReportingCaseMgmt
        mainRef={mainRef2}
        controlRef={controlRef}
        template={templateActive}
        setReportData={setReportData}
      />

      {/* Modals */}
      <CaseMgmtDurationModal
        show={showDurationModal}
        handleClose={() => setShowDurationModal(false)}
        currentDuration={currentConfig.duration}
        onSave={handleDurationSave}
      />

      <CaseMgmtReportValueModal
        show={showReportValueModal}
        handleClose={() => setShowReportValueModal(false)}
        currentValues={currentConfig.reportValues}
        currentScreenBy={currentConfig.screenBy}
        onSave={handleReportValuesSave}
        caseStages={caseStages}
        caseStatuses={caseStatuses}
      />

      <CaseMgmtSaveTemplateModal
        show={showSaveTemplateModal}
        handleClose={() => setShowSaveTemplateModal(false)}
        templateActive={templateActive}
        onSave={handleSaveTemplate}
      />

      <ExportReportModal
        show={downloadModal}
        handleClose={() => setDownloadModal(false)}
        template={templateActive}
        reportData={reportData}
        onExport={handleExport}
      />
    </>
  );
};

export default CaseMgmtHeader;
